export const aboutTexts = [
  `Lulu, la fundadora, es una pekinesa local que conoce muy bien Beijing y que viajado anualmente a 
  latinoamérica y España, conoce muy bien su cultura y las necesitades de los viajeros, no se siente frontera comunicando con ella.`,
  `Contamos con certificados oficiales de guía en español e inglés.`,
  `Tendrás comunicación rápida y eficiente con información clara y detallada.`,
  `Con 10 años de experiencia trabajando en viajes de negocios o turismo con hispanohablantes, tenemos 
 contacto de los traductores cualificados y agente de compras para sus importaciones en toda china.`,
  `Ofrecemos solución para cambio de moneda, SIM card y otros problemas durante el viaje.`,
];
